var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import CtaButton from '../../../components/CtaButton';
import RepositionPhotoAction from '../../PhotoEditor/RepositionPhotoAction';
import CopyPhotoAction from '../../PhotoEditor/CopyPhotoAction';
import DeletePhotoAction from '../../PhotoEditor/DeletePhotoAction';
var SimplePhotoListActions = /** @class */ (function (_super) {
    __extends(SimplePhotoListActions, _super);
    function SimplePhotoListActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimplePhotoListActions.prototype.render = function () {
        return (React.createElement("div", { className: "c-simple-photo-list__item__actions" },
            React.createElement(RepositionPhotoAction, { selectedPhoto: this.props.photo },
                React.createElement(CtaButton, { icon: "reposition", label: "order.products.control.edit.title", modifier: ['pink-100', 'icon-left', 'full'] })),
            React.createElement("div", { className: "h-margin-top--10" },
                React.createElement(CopyPhotoAction, { cartItem: this.props.cartItem, selectedPhoto: this.props.photo },
                    React.createElement(CtaButton, { icon: "copy", label: "order.products.control.copy.title", modifier: ['pink-100', 'icon-left', 'full'] }))),
            React.createElement("div", { className: "h-margin-top--10" },
                React.createElement(DeletePhotoAction, { selectedPhoto: this.props.photo },
                    React.createElement(CtaButton, { icon: "remove", label: "order.products.control.delete.title", modifier: ['pink-100', 'icon-left', 'full'] })))));
    };
    return SimplePhotoListActions;
}(React.Component));
export default SimplePhotoListActions;
